<!-- version 2021/05/20 -->
<template>
  <input
    type="text"
    :placeholder="placeholder"
    :value="textValue"
    :name="name"
    :maxlength="maxlength"
    @change="change"
  >
</template>

<script>
export default {
  events: {
    change: "change",
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    maxlength: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      textValue: this.text,
    };
  },
  methods: {
    change(event) {
      this.$emit("change", event, this);
    },
  },
};
</script>

<style lang="sass" scoped>
input[type='text']
  padding: 0.375rem 0.75rem
  font-size: 1rem
  color: #495057
  border: 1px solid #ced4da
  border-radius: 0.25rem
</style>
